/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import Head from 'next/head'
import {
  Box,
  Divider,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { useTabsJob } from './tabs-job.styles'
import { useRouter } from 'next/router'
import { SERVICES_URL, useLocale, useTranslation } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

export type ITabsJobProps = {
  place: string
  title?: components['schemas']['ProductTagResource']
}

export const TabsJob: FC<ITabsJobProps> = ({ place, title }) => {
  const locale = useLocale()
  const url = SERVICES_URL
  const { data: translate } = useTranslation()
  const [value, setValue] = useState<string>(place)
  const [valuePlace, setValuePlace] = useState('')
  const { push } = useRouter()
  const classes = useTabsJob()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(960))

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValuePlace(newValue)
    setValue(newValue)
  }

  const titles = {
    projects: translate?.projects ?? '',
    models: translate?.models ?? '',
    goods: translate?.market.goods ?? 'Товары'
  }

  const pages = [
    { value: 'projects', label: translate?.projects ?? '' },
    { value: 'models', label: translate?.models ?? '' },
    { value: 'goods', label: translate?.market.goods ?? 'Товары' }
  ]

  useEffect(() => {
    if (valuePlace === 'projects') {
      push(locale === 'ru' ? `${url.shop}/ru/projects` : `${url.shop}/projects`)
    }
    if (valuePlace === 'models') {
      push(locale === 'ru' ? `${url.shop}/ru/models` : `${url.shop}/models`)
    }
    if (valuePlace === 'goods') {
      push(locale === 'ru' ? `${url.shop}/ru/goods` : `${url.shop}/goods`)
    }
  }, [locale, push, valuePlace, url.shop])

  return (
    <Box className={classes.root}>
      {title?.seoTitle && (
        <Head>
          <title>{title.seoTitle}</title>
        </Head>
      )}
      <Typography className={classes.title} variant="h1">
        {title?.title
          ? title.title
          : `${translate?.market.title} - ${
              titles?.[value as keyof typeof titles]
            }` ?? ''}
      </Typography>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
      >
        {pages.map((page) => (
          <Tab
            key={page.value}
            value={page.value}
            label={page.label}
            className={classes.tab}
          />
        ))}
      </Tabs>
      {!isMobile && <Divider className={classes.divider} />}
    </Box>
  )
}
